export default {
  data() {
    return {
      valid: {
        category: false,
        image: true,
        name: false,
        description: false,
        sellingPrice: false,
        maxPrice: false,
        wholesalePrice: false,
      },
      success: {
        category: false,
        image: false,
        name: false,
        description: false,
        sellingPrice: false,
        maxPrice: false,
        wholesalePrice: false,
      },
      error: {
        category: '',
        image: '',
        name: '',
        description: '',
        sellingPrice: '',
        maxPrice: '',
        wholesalePrice: '',
      },
      errorMessages: {
        categoryRequired: {
          el: 'Η κατηγορία είναι υποχρεωτική',
          en: 'Category is required',
          it: 'La categoria è obbligatoria',
        },
        nameRequired: {
          el: 'Το όνομα είναι υποχρεωτικό',
          en: 'Name is required',
          it: 'Il nome è obbligatorio',
        },
        descriptionRequired: {
          el: 'Η περιγραφή είναι υποχρεωτική',
          en: 'Description is required',
          it: 'La descrizione è obbligatoria',
        },
        sellingPriceRequired: {
          el: 'Η τιμή πώλησης είναι υποχρεωτική',
          en: 'Selling Price is required',
          it: 'Il prezzo di vendita è obbligatorio',
        },
        sellingPriceMin: {
          el: 'Η τιμή πώλησης πρέπει να είναι τουλάχιστον 0,1',
          en: 'Selling Price must be minimum 0.1',
          it: 'Il prezzo di vendita deve essere almeno 0,1',
        },
        wholesalePriceMin: {
          el: 'Η χονδρική τιμή πρέπει να είναι τουλάχιστον 0,1',
          en: 'Wholesale Price must be minimum 0.1',
          it: "Il prezzo all'ingrosso deve essere almeno 0,1",
        },
        maxPriceMin: {
          el: 'Μέγιστη τιμή ανά συναλλαγή Η τιμή πρέπει να είναι τουλάχιστον 0,1',
          en: 'Maximum price per transaction Price must be minimum 0.1',
          it: 'Prezzo massimo per transazione Il prezzo deve essere minimo 0,1',
        },
        imageTooLarge: {
          el: 'Η εικόνα υπερβαίνει το όριο %dKB',
          en: 'Image exceeds %dKB limit',
          it: "L'immagine supera il limite di %dKB",
        },
        imageInvalidType: {
          el: 'Η εικόνα πρέπει να είναι PNG/JPG/JPEG',
          en: 'Image must be png/jpg/jpeg',
          it: "L'immagine deve essere png/jpg/jpeg",
        },
      },
    };
  },

  computed: {
    formValid() {
      return (
        this.valid.category &&
        this.valid.image &&
        this.valid.name &&
        this.valid.description &&
        this.valid.sellingPrice &&
        this.valid.wholesalePrice &&
        this.valid.maxPrice
      );
    },
  },

  methods: {
    validateImage(file) {
      if (!file) {
        this.error.image = '';
        this.valid.image = true;
        this.success.image = false;
        return true;
      }

      const maxKB = 5000;
      const maxBytes = maxKB * 1024;
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];

      if (file.size > maxBytes) {
        const msgTemplate =
          this.errorMessages.imageTooLarge[this.lang] || `Image exceeds ${maxKB}KB limit`;
        this.error.image = msgTemplate.replace('%d', maxKB);
        this.valid.image = false;
        this.success.image = false;
        return false;
      }

      if (!allowedTypes.includes(file.type)) {
        this.error.image = this.errorMessages.imageInvalidType[this.lang];
        this.valid.image = false;
        this.success.image = false;
        return false;
      }

      this.error.image = '';
      this.valid.image = true;
      this.success.image = true;
      return true;
    },
    validateCategory() {
      if (!this.product.product_category_id) {
        this.error.category = this.errorMessages.categoryRequired[this.lang];
      } else {
        this.error.category = '';
      }
    },

    validateName() {
      if (this.productLang === 'el') {
        if (!this.product.name['el']) {
          this.error.name = this.errorMessages.nameRequired[this.lang];
        } else {
          this.error.name = '';
        }
      }
    },

    validateDescription() {
      if (this.descriptionLang === 'el') {
        if (!this.product.description['el']) {
          this.error.description = this.errorMessages.descriptionRequired[this.lang];
        } else {
          this.error.description = '';
        }
      }
    },

    validateSellingPrice() {
      if (!this.product.retail_price) {
        this.error.sellingPrice = this.errorMessages.sellingPriceRequired[this.lang];
      } else if (this.product.retail_price < 0.1) {
        this.error.sellingPrice = this.errorMessages.sellingPriceMin[this.lang];
      } else {
        this.error.sellingPrice = '';
      }
    },

    validateWholesalePrice() {
      if (!this.product.wholesale_price) {
        this.error.wholesalePrice = '';
      } else if (this.product.wholesale_price < 0.1) {
        this.error.wholesalePrice = this.errorMessages.wholesalePriceMin[this.lang];
      } else {
        this.error.wholesalePrice = '';
      }
    },

    validateMaxPrice() {
      if (Number(this.product.maximum_price_per_transaction) == 0) {
        this.error.maxPrice = '';
      } else if (this.product.maximum_price_per_transaction < 0.1) {
        this.error.maxPrice = this.errorMessages.maxPriceMin[this.lang];
      } else {
        this.error.maxPrice = '';
      }
    },
  },

  watch: {
    ['product.product_category_id']: {
      immediate: true,
      handler(val) {
        this.valid.category = !!val;
        this.success.category = !!val;
      },
    },

    productLang(val) {
      if (val === 'en' || val === 'it') {
        this.error.name = '';
      }
    },

    descriptionLang(val) {
      if (val === 'en' || val === 'it') {
        this.error.description = '';
      }
    },

    ['product.name.el']: {
      immediate: true,
      handler(val) {
        this.valid.name = !!val;
        this.success.name = !!val;
      },
    },

    ['product.description.el']: {
      immediate: true,
      handler(val) {
        this.valid.description = !!val;
        this.success.description = !!val;
      },
    },

    ['product.retail_price']: {
      immediate: true,
      handler(val) {
        this.valid.sellingPrice = val >= 0.1;
        this.success.sellingPrice = val >= 0.1;
      },
    },

    ['product.wholesale_price']: {
      immediate: true,
      handler(val) {
        this.valid.wholesalePrice = val >= 0.1 || !val;
        this.success.wholesalePrice = val >= 0.1;
      },
    },

    ['product.maximum_price_per_transaction']: {
      immediate: true,
      handler(val) {
        this.valid.maxPrice = val >= 0.1 || !Number(val);
        this.success.maxPrice = val >= 0.1;
      },
    },

    resetSuccess(val) {
      if (val) {
        this.success = {
          category: false,
          image: false,
          name: false,
          description: false,
          sellingPrice: false,
          maxPrice: false,
          wholesalePrice: false,
        };

        this.setResetSuccess(false);
      }
    },

    resetValidation: {
      immediate: true,
      handler(val) {
        if (val) {
          this.error = {
            category: '',
            image: '',
            name: '',
            description: '',
            maxPrice: '',
            sellingPrice: '',
            wholesalePrice: '',
          };

          this.setResetValidation(false);
        }
      },
    },
  },
};
